import { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import type { SessionUser } from '@ns-b2b/shared';
import { Button } from './ui';

interface PendingOverlayProps {
    user: SessionUser;
}

export function PendingOverlay({ user }: PendingOverlayProps) {
    const { refreshSession, logout } = useAuth();

    useEffect(() => {
        const interval = setInterval(() => refreshSession(), 30000);
        return () => clearInterval(interval);
    }, [refreshSession]);

    return (
        <div className="min-h-screen bg-neutral-50 flex items-center justify-center p-4">
            <div className="w-full max-w-sm text-center">
                {/* Avatar */}
                <div className="mb-6">
                    {user.picture ? (
                        <img
                            src={user.picture}
                            alt={user.name}
                            className="w-24 h-24 rounded-full mx-auto ring-4 ring-neutral-100 object-cover"
                        />
                    ) : (
                        <div className="w-24 h-24 bg-primary rounded-full mx-auto flex items-center justify-center">
                            <span className="text-white text-3xl font-bold">
                                {user.name.charAt(0)}
                            </span>
                        </div>
                    )}
                </div>

                {/* Card */}
                <div className="card p-6">
                    {/* Badge */}
                    <div className="inline-flex items-center gap-2 bg-warning/10 text-warning px-3 py-1.5 rounded-lg text-sm font-medium mb-4">
                        <div className="w-2 h-2 bg-warning rounded-full animate-pulse-soft" />
                        รอการอนุมัติ
                    </div>

                    <h2 className="text-xl font-bold text-neutral-900 mb-2">
                        สวัสดี, {user.name}
                    </h2>

                    <p className="text-neutral-500 text-sm mb-6">
                        บัญชีของคุณกำลังรอการอนุมัติจากผู้ดูแลระบบ
                    </p>

                    {/* Loading */}
                    <div className="flex items-center justify-center gap-2 text-neutral-500 mb-6">
                        <div className="spinner w-4 h-4" />
                        <span className="text-sm">ตรวจสอบสถานะอัตโนมัติ...</span>
                    </div>

                    {/* Info */}
                    <div className="bg-neutral-50 rounded-xl p-4 text-left text-sm">
                        <p className="font-medium text-neutral-700 mb-2">หลังได้รับการอนุมัติ:</p>
                        <ul className="text-neutral-500 space-y-1">
                            <li>• บันทึกข้อมูลหน้างานได้</li>
                            <li>• ระบบรีเฟรชอัตโนมัติทุก 30 วินาที</li>
                        </ul>
                    </div>
                </div>

                {/* Actions */}
                <div className="flex gap-3 justify-center mt-6">
                    <Button onClick={() => refreshSession()} variant="secondary" size="sm">
                        ตรวจสอบสถานะ
                    </Button>
                    <Button onClick={() => logout()} variant="ghost" size="sm">
                        ออกจากระบบ
                    </Button>
                </div>
            </div>
        </div>
    );
}
